const selectionProcesses = [
	{
		path: '/jobs/selection-processes',
		name: 'jobs-selection-processes-list',
		component: () => import(/* webpackChunkName: "SelectionProcessesList" */ '@/views/jobs/selection-processes/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,selection-processes',
		},
	},
	{
		path: '/jobs/selection-processes/create',
		name: 'jobs-selection-processes-create',
		component: () => import(/* webpackChunkName: "SelectionProcessesCreate" */ '@/views/jobs/selection-processes/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,selection-processes',
		},
	},
	{
		path: '/jobs/selection-processes/:id/candidates',
		name: 'jobs-selection-processes-candidates',
		component: () => import(/* webpackChunkName: "SelectionProcessesCandidates" */ '@/views/jobs/selection-processes/candidates.vue'),
		meta: {
			layout: 'content',
			module: 'MGJ,selection-processes',
		},
	},
]

export default selectionProcesses
